import { render } from "./OwnedStories.vue?vue&type=template&id=ad277216"
import script from "./OwnedStories.vue?vue&type=script&lang=js"
export * from "./OwnedStories.vue?vue&type=script&lang=js"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__